import * as React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from 'components/ui/Box';
import { Form, FormField } from 'components/ui/form';
import { ComboboxGs, InputGs } from 'components/ui/Forms';
import { Button } from 'components/ui/ButtonGs';
import { ActivityIndicator } from 'styles/components';

import { formSchema } from './form-schema';
import type { FormSchema, UploadType } from './form-schema';

export type UploadDataPayload = {
  uploadType: UploadType;
  file: File;
}

type Props = {
  onSubmit: (data: UploadDataPayload) => void;
  loading?: boolean;
};

const UPLOAD_TYPE_OPTIONS: Array<{ value: UploadType, name: string }> = [
  { value: 'blocked-products', name: 'Produtos' },
  { value: 'blocked-product-reasons', name: 'Motivos' },
  { value: 'blocked-product-prices', name: 'Custos' },
  { value: 'planner-and-material-association', name: 'Planejadores por produto' },
  { value: 'destination-plant-material-association', name: 'Materiais por planta de destino' },
];

export const UploadDataForm = ({ onSubmit, loading }: Props) => {
  const form = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
  });

  const onFormSubmit = React.useCallback((formData: FormSchema) => {
    onSubmit({
      file: formData.file[0],
      uploadType: formData.uploadType,
    });
  }, [onSubmit]);

  return (
    <Box className={'w-full'}>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onFormSubmit)}
          className="flex flex-row gap-4 pb-10"
        >
          <div className={'w-full grid grid-cols-2 gap-4'}>
            <FormField
              control={form.control}
              name={'uploadType'}
              render={({ field }) => (
                <ComboboxGs
                  form={form}
                  fieldName={field.name}
                  fieldValue={field.value}
                  content={UPLOAD_TYPE_OPTIONS}
                  label={'Tipo de planilha'}
                />
              )}
            />
            <FormField
              control={form.control}
              name={'file'}
              render={() => (
                <InputGs
                  type={'file'}
                  label={'Arquivo'}
                  {...form.register('file')}
                />
              )}
            />
          </div>
          <div className={'mt-[25px] w-40 shrink-0'}>
            <Button.Root className={'w-full'} type={'submit'} size={'sm'} disabled={loading}>
              {loading ? <ActivityIndicator /> : 'Enviar planilha'}
            </Button.Root>
          </div>
        </form>
      </Form>
    </Box>
  );
};